<script setup lang="ts">
import { NButton, NModal } from 'naive-ui'

defineProps<{ show: boolean; name: string }>()
const emit = defineEmits<{ 'update:show': [value: boolean]; confirm: [] }>()
</script>

<template>
  <NModal
    :show="show"
    preset="card"
    :title="`Delete #${name}?`"
    class="max-w-md"
    @update:show="emit('update:show', $event)"
  >
    <p class="text-sm m-0 mb-4">
      This permanently deletes the channel and all its messages. Member threads are not deleted.
    </p>
    <div class="flex justify-end gap-2">
      <NButton @click="emit('update:show', false)">Cancel</NButton>
      <NButton type="error" data-testid="delete-confirm" @click="emit('confirm')">Delete channel</NButton>
    </div>
  </NModal>
</template>
